// AUTO GENERATED FILE - Changes WILL be lost.
export const translations = {
  "betslip.title": "投註單",
  "last60.fixture": "{visitor} {'@'} {home}",
  "last60.fixtureResult": "{visitor} ({visitorScore}) {'@'} ({homeScore}) {home}",
  "sb.fixture": "{home} VS. {away}",
  "sb.fixtureResult": "{home} {homeScore} - {awayScore} {away}",
  "betslip.bet": "下註",
  "betslip.clear": "全部清除",
  "betslip.clearResult": "清除",
  "betslip.noSelections": "添加選項以開始投註",
  "betslip.notLoggedIn": "登錄以開始投注",
  "betslip.refresh": "刷新",
  "betslip.totalStake": "總投註金",
  "betslip.noHistoryData": "無投註信息",
  "betslip.openBets": "投註未結算",
  "betslip.betHistory": "下註紀錄",
  "betslip.betHistoryWon": "贏",
  "betslip.betHistoryLost": "輸",
  "loading.loading": "加載中",
  "loading.account": "登錄帳號中",
  "loading.league": "載入聯賽",
  "loading.gameweeks": "載入比賽時間表",
  "loading.markets": "載入盤口",
  "loading.bethistory": "正在加載下註紀錄",
  "login.loginRequired": "需要登錄",
  "login.loginToBet": "請登錄以開始投注",
  "navigation.back": "返回",
  "navigation.close": "關閉",
  "video.liveStreamAvailable": "直播可用",
  "video.logInToWatch": "請登錄觀看",
  "error.error": "錯誤",
  "error.404": "網頁未找到",
  "error.gameLaunchFailed": "無法啟動",
  "error.unknownErrorCode": "未知錯誤: {code}",
  "error.minUnitStakeLimitExceeded": "最低投注額 {limit}",
  "error.maxUnitStakeLimitExceeded": "最高投注額 {limit}",
  "error.minTotalStakeLimitExceeded": "最低投注總額 {limit}",
  "error.maxTotalStakeLimitExceeded": "最高投注總額 {limit}",
  "error.notPlaced": "未投註",
  "error.wagerDisallowed": "禁止下注",
  "error.errorEventIsOff": "賽事已開始",
  "multiplebet.Singles": "單式投註",
  "multiplebet.Doubles": "二串壹",
  "multiplebet.Trebles": "三串壹",
  "multiplebet.Accumulator": "累計",
  "multiplebet.Perm 4-Folds": "四串壹",
  "multiplebet.Perm 5-Folds": "五串壹",
  "multiplebet.Perm 6-Folds": "六串壹",
  "multiplebet.Perm 7-Folds": "七串壹",
  "multiplebet.Perm 8-Folds": "八串壹",
  "multiplebet.Perm 9-Folds": "九串壹",
  "sb-english.team.ARS": "阿森納",
  "sb-english.team.AST": "拉斯维",
  "sb-english.team.BHA": "布来頓",
  "sb-english.team.BOU": "博尼茅斯",
  "sb-english.team.BUR": "伯恩利",
  "sb-english.team.CHE": "切爾西",
  "sb-english.team.CRY": "C. 宮",
  "sb-english.team.EVE": "埃弗頓",
  "sb-english.team.LEI": "萊切斯特",
  "sb-english.team.LIV": "利物浦",
  "sb-english.team.MNC": "曼徹斯特. C",
  "sb-english.team.MNU": "曼徹斯特聯盟",
  "sb-english.team.NEW": "紐卡斯爾",
  "sb-english.team.SOU": "南安普敦",
  "sb-english.team.TOT": "托特納姆",
  "sb-english.team.WAT": "沃特福德",
  "sb-english.team.WHU": "西漢姆",
  "sb-english.team.WOL": "伍爾弗",
  "sb-english.team.NOR": "諾維奇",
  "sb-english.team.SHU": "谢菲尔德. U",
  "sb-english.team.LEE": "利茲",
  "sb-english.team.FUL": "富勒姆",
  "sb-english.team.WBA": "西布羅姆",
  "nomorebets": "投註結束",
  "playtime": "上場時間",
  "gameId": "賽事ID",
  "noGames": "無可用賽事，請稍後再回來查看",
  "Home": "主",
  "Away": "客",
  "Visitor": "客",
  "soccerbet.gameWeek": "賽事周",
  "soccerbet.noGameWeeks": "沒有比賽時間表，請稍後再查看",
  "soccerbet.league": "聯賽排名",
  "soccerbet.table.name": "名稱",
  "soccerbet.table.won": "贏",
  "soccerbet.table.drawn": "和",
  "soccerbet.table.lost": "輸",
  "soccerbet.table.points": "比分",
  "market.abbr.Both Teams To Score": "兩隊得分",
  "market.Both Teams To Score": "兩隊都進球",
  "market.Over / Under": "大/小",
  "market.Double Chance": "雙重機會",
  "market.Match Result": "比賽結果",
  "market.Exact Goals": "正確比分",
  "market.Correct Score": "波膽",
  "market.Match Result Both Score": "比賽結果雙方得分",
  "market.Result Und/Over 1.5 Total Goals": "賽事結果/小 1.5 總分",
  "market.Result Und/Over 2.5 Total Goals": "賽事結果大/小 2.5 總分",
  "market.Under Over 1.5 Total Goals": "大/小1.5 總分",
  "market.Under Over 2.5 Total Goals": "大/小2.5 總分",
  "market.Under Over 3.5 Total Goals": "大/小3.5 總分",
  "market.Under Over 4.5 Total Goals": "大/小4.5 總分",
  "market.Total Goals 1 To 2": "總進球數1至2",
  "market.Total Goals 1 To 3": "總進球數1至3",
  "market.Total Goals 1 To 4": "總進球數1至4",
  "market.Total Goals 2 To 3": "總進球數2至3",
  "market.Total Goals 2 To 4": "總進球數2至4",
  "market.Under Over 1.5 Home Goals": "大/小 1.5 主隊得分",
  "market.Under Over 1.5 Away Goals": "大/小 1.5 客隊得分",
  "market.Home Team Exact Goals": "主隊正確比分",
  "market.Away Team Exact Goals": "客隊正確比分",
  "selection.Yes": "是",
  "selection.No": "否",
  "selection.1+G": "1+进球",
  "selection.1+Ng": "1+没有进球",
  "selection.X+G": "X+进球",
  "selection.X+Ng": "X+没有进球",
  "selection.2+G": "2+进球",
  "selection.2+Ng": "2+没有进球",
  "selection.1+Yes": "1+是",
  "selection.1+No": "1+否",
  "selection.X+Yes": "X+是",
  "selection.X+No": "X+否",
  "selection.2+Yes": "2+是",
  "selection.2+No": "2+否",
  "selection.TID_ANY_GOAL_SCORED_YES": "进球",
  "selection.TID_ANY_GOAL_SCORED_NO": "没有进球",
  "selection.U": "小",
  "selection.O": "大",
  "selection.1+O": "1+大",
  "selection.X+O": "X+大",
  "selection.2+O": "2+大",
  "selection.1+U": "1+小",
  "selection.X+U": "X+小",
  "selection.2+U": "2+小",
  "selection.TID_HOME_WIN": "1",
  "selection.TID_AWAY_WIN": "2",
  "selection.TID_DRAW": "X",
  "selection.TID_HOME_WIN_OR_DRAW": "1x",
  "selection.TID_DRAW_OR_AWAY_WIN": "x2",
  "selection.TID_HOME_OR_AWAY_WIN": "12"
}
